<template>
<div>
   <vs-row vs-type="flex">
      <ValidationObserver ref="addMultipleObserver">
        <vs-col vs-justify="flex-start" vs-lg="3" class="p-3">
          <ValidationProvider :name="$t('CashFlow.YearlyFxRate.Currency')" rules="required" v-slot="{ errors }">
            <form-label>{{$t('CashFlow.YearlyFxRate.Currency')}}</form-label>
            <v-select
              :options="currencies"
              label="name"
              :reduce="currency => currency.id"
              v-model="currency"
              class="w-full"
              name="currencyId"
            />
            <validation-message>{{ errors[0] }}</validation-message>
          </ValidationProvider>
        </vs-col>
        <vs-col vs-justify="flex-start" vs-lg="2" class="p-3">
          <ValidationProvider :name="$t('CashFlow.YearlyFxRate.StartYear')" rules="required|numeric|between:1990,2100" v-slot="{ errors }">
            <validated-input :label="$t('CashFlow.YearlyFxRate.StartYear')" 
              v-model="startYear"
              class="nowrap">
            </validated-input>
            <validation-message>{{ errors[0] }}</validation-message>
          </ValidationProvider>
        </vs-col>
        <vs-col vs-justify="flex-start" vs-lg="2" class="p-3">
          <ValidationProvider :name="$t('CashFlow.YearlyFxRate.EndYear')" rules="required|numeric|between:1990,2100" v-slot="{ errors }">
            <validated-input :label="$t('CashFlow.YearlyFxRate.EndYear')" 
              v-model="endYear"
              class="nowrap">          
            </validated-input>
            <validation-message>{{ errors[0] }}</validation-message>
          </ValidationProvider>
        </vs-col>
        <vs-col vs-justify="flex-start" vs-lg="1" class="p-3">
          <ValidationProvider :name="$t('CashFlow.YearlyFxRate.Rate')" rules="required|decimal|min_value:0" v-slot="{ errors }">
            <validated-input :label="$t('CashFlow.YearlyFxRate.Rate')" 
              v-model="rate"
              class="nowrap">
            </validated-input>
            <validation-message>{{ errors[0] }}</validation-message>
          </ValidationProvider>
        </vs-col>
        <vs-col v-if="!readOnly" vs-type="flex" vs-justify="flex-start" vs-lg="3" class="align-items-center mt-8 pt-1" >
          <vs-button type="border" class="align-items-center" color="danger" @click="addMultipleRates" >{{ $t('CashFlow.YearlyFxRate.BatchAddTitle') }}</vs-button>
        </vs-col>
      </ValidationObserver>
    </vs-row>
    <vs-row class="yesscroll mb-10">
      <yearly-fx-rates-table :yearlyRates="yearlyRates" />
    </vs-row>
</div>

</template>
<script>

import CurrencyEnum from "./../../../CurrencyEnum.js";
import vSelect from 'vue-select';
import YearlyFxRatesTable from './yearlyFxRatesTable.vue'

import {
  FormLabel,
  ValidatedInput,
  ValidationMessage
} from "@/app/shared/components";

export default {
  /* eslint-disable vue/no-unused-components */
  components: {
    FormLabel,    
    vSelect,
    ValidatedInput,
    ValidationMessage,
    YearlyFxRatesTable
  },
  props: {
    readOnly : {
      type: Boolean,
      default: false
    },
    templateId : {
      type: Number
    },
    yearlyRates: {
      type: Array,
      default: () => {}
    }
  },
  data() {
    return {
      isMounted: false,
      startYear: null,
      endYear: null,
      currency: null,
      rate: 0,
      context: { componentParent: this },
      currencies: [
        { name: this.getCurrencyName(CurrencyEnum.CAD), id: CurrencyEnum.CAD },
        { name: this.getCurrencyName(CurrencyEnum.EUR), id: CurrencyEnum.EUR },
        { name: this.getCurrencyName(CurrencyEnum.MXN), id: CurrencyEnum.MXN },
        { name: this.getCurrencyName(CurrencyEnum.AUD), id: CurrencyEnum.AUD }
      ]
    };
  },
  created() {
    this.initValues();
  },

  computed: {
  },

  methods: {
    initValues() {
      if (this.data) return;
      this.startYear = new Date().getFullYear();
      this.endYear = null;
      this.currency = CurrencyEnum.CAD;
      this.rate = 0;
    },
    addMultipleRates() {
      this.$refs.addMultipleObserver.validate().then(result => {
        if (result) {
          this.$vs.loading();
          this.$cqrsPost('cashflow/lom/yearlyFxRateTemplates/addMultipleRates', { 
            templateId: this.templateId,
            currency: this.currency,
            startYear: this.startYear,
            endYear: this.endYear,
            rate: this.rate
          }).then((response) => {
            this.$notifySaveSuccess();
            this.$emit("onRebindYearlyRates", response.data.model);
          }).finally(() => {
            this.$vs.loading.close();
          });
        }
      });
    },
    getCurrencyName(currency) {
      return this.$t("CashFlow.Currency." + currency);
    }
  }
};
</script>

<style lang="scss">


  .nowrap {
    white-space: nowrap;
  }

  .noscroll {
    overflow: initial !important;
  }

  .yesscroll {
    overflow-x: auto;
  }

</style>